export default "__VITE_ASSET__5698938a__"